// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AwsVPC } from './AwsVPC';
import {
  AwsVPCFromJSON,
  AwsVPCFromJSONTyped,
  AwsVPCToJSON,
  AwsVPCToJSONTyped,
} from './AwsVPC';

/**
 *
 * @export
 * @interface AwsNetwork
 */
export interface AwsNetwork {
  /**
   *
   * @type {AwsVPC}
   * @memberof AwsNetwork
   */
  vpc?: AwsVPC;
  /**
   *
   * @type {Array<string>}
   * @memberof AwsNetwork
   */
  zones?: Array<string>;
}

/**
 * Check if a given object implements the AwsNetwork interface.
 */
export function instanceOfAwsNetwork(value: object): value is AwsNetwork {
  return true;
}

export function AwsNetworkFromJSON(json: any): AwsNetwork {
  return AwsNetworkFromJSONTyped(json, false);
}

export function AwsNetworkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsNetwork {
  if (json == null) {
    return json;
  }
  return {
    vpc: json['vpc'] == null ? undefined : AwsVPCFromJSON(json['vpc']),
    zones: json['zones'] == null ? undefined : json['zones'],
  };
}

export function AwsNetworkToJSON(json: any): AwsNetwork {
  return AwsNetworkToJSONTyped(json, false);
}

export function AwsNetworkToJSONTyped(
  value?: AwsNetwork | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    vpc: AwsVPCToJSON(value['vpc']),
    zones: value['zones'],
  };
}
